/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GPS location
 * @export
 * @interface ApiLocation
 */
export interface ApiLocation {
    /**
     * 
     * @type {number}
     * @memberof ApiLocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof ApiLocation
     */
    longitude: number;
}

export function ApiLocationFromJSON(json: any): ApiLocation {
    return ApiLocationFromJSONTyped(json, false);
}

export function ApiLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function ApiLocationToJSON(value?: ApiLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

